export const ACC_ROUTES = {
  LOGIN: "/account/login",
  FORGOT_PASSWORD: "/account/forgot-password",
  PASSWORD_RESET: "/account/password-reset",
  CHANGE_PASSWORD: "/account/change-password",
  REGISTER: "/account/register",
  PROFILE: "/Webuser/profile",
};

export const ENQUIRY_ROUTES = {
  LIST: "/enquiry/list",
  EXPORT: "/enquiry/export",
  DETAIL: "/enquiry/detail",
  DETAIL_SAVE: "/enquiry/detail/save",
  COURSE_ADD: "/enquiry/course/add",
  DELETE: "/enquiry/delete",
};

export const FOLLOWUP_ROUTES = {
  LIST: "/follow-up/list",
  STATUS_UPDATE: "/follow-up/update-status",
  DETAIL: "/follow-up/detail",
  DETAIL_SAVE: "/follow-up/detail",
};

export const CATEGORY_ROUTES = {
  LIST: "/category/list",
  DETAIL: "/category/detail",
  DETAIL_SAVE: "/category/detail",
  DELETE: "/category/delete",
};

export const COURSE_ROUTES = {
  LIST: "/course/list",
  DETAIL: "/course/detail",
  DETAIL_SAVE: "/course/detail",
  DELETE: "/course/delete",
};

export const COMMON_ROUTES = {
  DDL_LIST: "/dropdown/list",
  DASHBOARD: "/dashboard/graph/data",
  DASHBOARD_REPORT: "/dashboard/detail/data",
  STUDENTLIST: "/students-list",
};

export const WEBUSER_ROUTES = {
  LIST: "/Webuser/{userType}/user-list",
  DETAIL: "/Webuser/{userType}/detail",
  DETAIL_SAVE: "/Webuser/{userType}/detail/save/{id}",
  DELETE: "/Webuser/delete",
  PROFILE: "/account/profile",
};

export const BATCH_ROUTES = {
  LIST: "/batch/list",
  DETAIL: "/batch/detail",
  DETAIL_SAVE: "/batch/detail/save",
  DELETE: "/batch/delete",
  STUDENT_LIST: "/batch/student-list",
  STUDENT_SAVE: "/batch/add-student",
  STUDENT_DELETE: "/batch/student/delete",
};

export const STUDENT_ROUTES = {
  LIST: "/student/list",
  DETAIL: "/student/detail",
  DETAIL_SAVE: "/student/detail/save",
  DELETE: "/student/delete",
};

export const STUDENT_COURSE_FEE_ROUTES = {
  COURSE_FEE_DETAIL: "/student/course-fee/detail",
  COURSE_DETAIL: "/student/course/detail",
  COURSE_SAVE: "/student/course/save",
  COURSE_PAYMENT_DETAIL_LIST: "/student/course/payment/detail",
  PAY_COLLECTION: "/student/pay-collection",

  DELETE_COURSE_DETAIL: "/student/course/delete",
  DELETE_COURSE_FEE_PAYMENT_DETAIL: "/student/course/fee/payment/delete",
  COURSE_FEE_PAYMENT_DETAIL_GET: "/student/course/payment/save",
  COURSE_FEE_PAYMENT_DETAIL_POST: "/student/course/payment/save",
  COURSE_FEE_PAYMENT_EMI_POST: "/student/course/emi/status/update",
};

export const ATTENDANCE_ROUTES = {
  GET_ATTENDANCE_LIST: "/attendance/list",
  SAVE_ATTENDANCE: "/attendance/save",
  HISTORY: "/attendance/history",
  HISTORY_LIST: "/attendance/history-list",
  REPORT: "/attendance/report",
};
